import $ from "jquery";
import React, { Component } from "react";
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from "react-redux";
import { Row } from "react-foundation";

import { getDoorStyles } from "actions";
import Tick from "components/Tick";
import Loading from "components/Loading";
import SlickSlider from "components/SlickSlider";

import validate from "../validate";
import utils from "utils";

import Image from "components/Image";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import FormWrapper from "../../FormWrapper";
import FormHeader from "../../../components/FormHeader";
import { updatePreviousSelection } from '../../../actions';

class SelectStyle extends Component {
    renderStyle(value, id, selectedValue) {
        let selectedClass = id === selectedValue.toString() ? " selected" : "";

        return (
            <div key={id} className={selectedClass}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <Image
                        src={value.externalImageUrl}
                        svg={value.svgImage}
                        placeholderText={value.name}
                        alt=""
                        className="slick-slide-image"
                    />
                </div>
                <p className={"slick-slide-title"}>{value.groupingHierarchy2.value}</p>
            </div>
        );
    }

    render() {
        let { styles, input } = this.props;

        if ($.isEmptyObject(styles)) {
            return <Loading />;
        }


        return (
            <div>
                <Row isColumn>
                    <SlickSlider
                        values={styles}
                        selectedId={input.value}
                        onDisplay={(value, id) => this.renderStyle(value, id, input.value)}
                        onChange={input.onChange}
                    />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class StyleForm extends Component {
    componentDidMount() {
        // let itemTypeId = 1; // door

        this.props.getDoorStyles(this.props.doorTypeId);
    }

    componentDidUpdate() {
        let { selectedStyle, styles, dispatch, previousSelection } = this.props;

        if (!selectedStyle.id) {
            if (styles.length > 0) {
                // do something
                dispatch(change("DoorWizard", "DoorStyleId", previousSelection.DoorCompositeStyleId || styles[0]));
            }
        }
    }

    onSubmit(values) {
        let doorStyleId = values.DoorStyleId;

        let style = utils.getValueById(this.props.styles, doorStyleId);

        this.props.setStyleSettings(style);

        this.props.updatePreviousSelection({
            DoorCompositeStyleId: values.DoorStyleId
        });

        this.props.onSubmit();
    }

    render() {
        return (
            <form className="StyleForm composite" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader title={"Pick your style"} subtitle={""} />
                <SeparatingLine />

                <FormWrapper>
                    <Field name="DoorStyleId" component={SelectStyle} styles={this.props.styles} />
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />

                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorTypeId = valueSelector(state, "DoorTypeId");
    let doorStyleId = valueSelector(state, "DoorStyleId");

    let styles = state.Door.Styles.filter(s => s.isPrincipalStyle === true);

    let selectedStyle = styles.filter(c => c.id === doorStyleId)[0] || {};


    return {
        styles,
        doorTypeId,
        selectedStyle,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getDoorStyles, updatePreviousSelection })(
    reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        keepDirtyOnReinitialize: true,
        validate
    })(StyleForm)
);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/composite/StyleForm.js